import { AccountSecurityPanel } from "./AccountSecurityPanel";
import { PortalProfilePanel } from "./portal/PortalProfilePanel";
import { Breadcrumbs, PageHeader } from "./ui";
import { PortalPageIntro } from "./portal/PortalVisuals";

interface AccountPageProps {
  shell: "portal" | "staff";
}

export function AccountPage({ shell }: AccountPageProps) {
  if (shell === "portal") {
    return (
      <section className="space-y-8">
        <PortalPageIntro title="Your profile" />
        <div className="grid gap-5 xl:grid-cols-2 [&>*]:min-w-0 [&>*]:border-2">
          <PortalProfilePanel />
          <AccountSecurityPanel />
        </div>
      </section>
    );
  }

  return (
    <section className="space-y-4">
      <PageHeader
        title="Account"
        description="Manage your sign-in password and account security settings."
        breadcrumbs={
          <Breadcrumbs
            items={[
              { label: "Agents", to: "/dashboard/agents" },
              { label: "Account", current: true },
            ]}
          />
        }
      />
      <AccountSecurityPanel />
    </section>
  );
}
